import { createContext, useContext, useState, useCallback } from "react";
import { EventModal } from "@/components/EventModal";
import { TaskModal } from "@/components/TaskModal";

const UIContext = createContext(null);

export function UIProvider({ children }) {
  const [eventInitial, setEventInitial] = useState(null);
  const [taskInitial, setTaskInitial] = useState(null);
  const [searchOpen, setSearchOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const openEventModal = useCallback((initial = {}) => setEventInitial(initial), []);
  const openTaskModal = useCallback((initial = {}) => setTaskInitial(initial), []);

  return (
    <UIContext.Provider value={{ openEventModal, openTaskModal, searchOpen, setSearchOpen, sidebarOpen, setSidebarOpen }}>
      {children}
      <EventModal open={!!eventInitial} initial={eventInitial} onClose={() => setEventInitial(null)} />
      <TaskModal open={!!taskInitial} initial={taskInitial} onClose={() => setTaskInitial(null)} />
    </UIContext.Provider>
  );
}

export function useUI() { return useContext(UIContext); }
